import { render } from "./np-postcode-search.vue?vue&type=template&id=9fb614c4"
import script from "./np-postcode-search.vue?vue&type=script&lang=js"
export * from "./np-postcode-search.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__